export enum FleetRouterStateKey {
  CATEGORY = 'category',
  TYPE = 'type',
  TEMPLATE = 'template',
}
